import { Box, Stack, Typography } from '@mui/material'
import React from 'react'

const Home = () => {
  return (
    <Stack
          direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
          spacing={0}
          justifyContent={{ lg: 'center' }}
          flexGrow={1} pt={2} pb={2}
        >
          <Box bgcolor='white' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={2} style={{ width: '100%', borderRadius: 0 }} >
            <Typography variant="h5" component="h5" p={2} align='center'>
              Bienvenido a "Panadería Barrio Lindo"
            </Typography>

          </Box>
          <Box bgcolor='white' flex={4} padding={2} style={{ borderRadius: 0, width: '100%' }}>
            <Typography variant="h5" component="h5" p={2} align='center'>
              Para realizar ventas por favor ingrese a POS (Punto de Venta).
            </Typography>

            
          </Box>
        </Stack>
  )
}

export default Home